module.exports = __webpack_public_path__ + "img/mc-volume-off.68f99502.svg";